export const name = "REVERSE";
export const summary = `Reverses a \`STRING\` or \`BYTES\` value.`;
export const reference = `
## REVERSE

Reverses a \`STRING\` or \`BYTES\` value.

\`\`\`
REVERSE(value)
\`\`\`

### Description

Returns the reverse of the input \`STRING\` or \`BYTES\`.


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT REVERSE('abc') AS results

/*---------*
 | results |
 +---------+
 | cba |
 *---------*/
\`\`\`



\`\`\`
SELECT FORMAT('%T', REVERSE(b'1a3')) AS results

/*---------*
 | results |
 +---------+
 | b"3a1" |
 *---------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
